export default __webpack_public_path__ + "static/media/under-construction.2acbfe06.png";